import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './containers/App';
import configureStore from './store/configureStore';
import { Router } from 'react-router-dom';
import history from './history/history';
import registerServiceWorker from './registerServiceWorker';
import ScrollToTop from './helpers/RouterScrollTop';
//import './css/style.css';




const store = configureStore();
let rootElement = document.getElementById('root');


ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <ScrollToTop>
                <App />
            </ScrollToTop>
        </Router>
    </Provider>, rootElement);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js